export const AdminMenus = [
  {
    label: "Dashboard",
    key: "dashboard",
    icon: "ki-outline ki-element-11",
  },
  {
    label: "Manage User",
    key: "manage-user",
    icon: "ki-outline ki-profile-user ",
  },
  {
    label: "Train AI",
    key: "train-ai",
    icon: "ki-outline ki-abstract-26",
  },
  {
    label: "AI Chat Sessions",
    key: "ai-chat-sessions",
    icon: "ki-outline ki-messages",
  },
];
